module.exports = __webpack_public_path__ + "img/续费套餐.cd660386.svg";